import { render, staticRenderFns } from "./ExternalLoginBrandButton.vue?vue&type=template&id=24acf1c4&"
import script from "./ExternalLoginBrandButton.vue?vue&type=script&lang=ts&"
export * from "./ExternalLoginBrandButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports